import "./DeleteSectionModal.scss";

import { FC, useState } from "react";

import { serverDisconnectSection } from "api/api-server-actions";
import { t } from "i18n/i18n";
import { showConfirmationModal } from "mds/components/Modal";
import { TextField } from "mds/components/TextField";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useAppSelector } from "store/index";
import { selectCurrentCourseCode, selectLmsType } from "store/selectors";
import { toastSuccessMessage } from "utils/alerts";

export const showDisconnectConfirmationModal = ({
  sectionId,
  lmsType,
}: {
  sectionId: string;
  lmsType: string;
}) => {
  return showConfirmationModal({
    title: t("confirm_disconnect_modal.disconnect_item", { lms: lmsType }),
    hideCancelConfirmButtons: true,
    children: (onClose) => <DisconnectSectionModal sectionId={sectionId} onClose={onClose} />,
  });
};

type DisconnectSectionModalProps = {
  sectionId: string;
  onClose: () => void;
};

// eslint-disable-next-line react-refresh/only-export-components
const DisconnectSectionModal: FC<DisconnectSectionModalProps> = ({ sectionId, onClose }) => {
  const lmsType = useAppSelector(selectLmsType);
  const courseCode = useAppSelector(selectCurrentCourseCode);
  const buttonText = t("confirm_disconnect_modal.button_text");
  const [deletePagesAndAssessments, setDeletePagesAndAssessments] = useState<boolean>(true);
  const [disableDisconnect, setDisableDisconnect] = useState<boolean>(true);

  const handleCourseConfirmationCheck = (text: string) => {
    setDisableDisconnect(text !== courseCode);
  };

  const handleDisconnect = async () => {
    await serverDisconnectSection(sectionId, deletePagesAndAssessments);
    toastSuccessMessage(t("success.toasts.disconnect_section_success"));
    onClose();
  };

  return (
    <div className="section-delete-modal flex flex-col items-start gap-8">
      <div className="section-delete-warning">
        {t("confirm_disconnect_modal.disconnect_section_warning", { lms: lmsType })}
      </div>

      <label className="flex items-start gap-2">
        <input
          checked={deletePagesAndAssessments}
          className="mt-[0.1875rem]"
          type="checkbox"
          onChange={() => setDeletePagesAndAssessments(!deletePagesAndAssessments)}
        />
        <div>{t("confirm_disconnect_modal.clear_content_checkbox_text", { lms: lmsType })}</div>
      </label>
      <div className="flex flex-col gap-2">
        <label htmlFor="course-code">{t("section_list_panel.course_confirm_label")}</label>

        <TextField
          id="course-code"
          placeholder={t("section_list_panel.course_placeholder")}
          isEditing
          onChange={(event) => handleCourseConfirmationCheck(event.target.value)}
        />
      </div>

      <div className="flex w-full justify-end gap-2">
        <SquareButton kind="tertiary" size="m" title={t("common.cancel")} onClick={onClose}>
          {t("common.cancel")}
        </SquareButton>

        <SquareButton
          disabled={disableDisconnect}
          kind="caution"
          size="m"
          title={buttonText}
          onClick={handleDisconnect}
        >
          {buttonText}
        </SquareButton>
      </div>
    </div>
  );
};
